<template>
  <div class="label-list">
    <div
      v-for="item in options"
      :key="item.id"
      :class="['label-item', { 'is-active': value === item.id }]"
      :style="{ backgroundColor: item.color }"
      @click="changeLabel(item)"
    >
      <div>{{ item.label }}</div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineExpose, defineEmits } from "vue";

/* emits */
const emit = defineEmits(["change"]);

/* state */
const value = ref(null);
const options = ref([]);

/* methods */

// 选中标签
function changeLabel(item) {
  return new Promise((resolve) => {
    value.value = item.id;
    emit("change", item);
    setTimeout(resolve, 200);
  });
}

// 外部设置标签
function setOptions(list) {
  options.value = list || [];
  value.value = null;
}

/* 向父组件暴露方法（Vue3 关键） */
defineExpose({
  setOptions,
  changeLabel,
});
</script>

<style scoped lang="less">
.label-list {
  padding: 12px 12px 0 20px;
  width: 160px;

  .label-item {
    padding: 8px;
    margin-bottom: 8px;
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.is-active {
      outline: 2px solid #409eff;

      &::after {
        content: "";
        position: absolute;
        left: -20px;
        top: 50%;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-top: 12px solid transparent;
        border-bottom: 12px solid transparent;
        border-left: 12px solid #409eff;
      }
    }

    .label-btn {
      cursor: pointer;
    }
  }
}
</style>
